<div class="page-padding">
  <!--<div class="center" *ngIf="equipmentDetails == null">
    <mat-spinner></mat-spinner>
  </div>-->
  <div class="panel" *ngIf="equipmentDetails != null" [@enterAnimation]>
    <div class="panel__header">
      <div style="display: flex; flex-direction: row;">
        <div>
          <span class="panel__header__title">
            {{ Translate('Equipment Details') }} - <span
              style="color: gray; font-size: 16px;">{{equipmentDetails.EqStatus}} </span>

            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>create</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item *ngFor="let status of allEquipmentStatus.Data"
                (click)="UpdateEqStaus(status.Id, status.EqStatusName)">
                <span>{{ status.EqStatusName }}</span>
              </button>
            </mat-menu>
            <!-- <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="UpdateEqStaus(0,'Not in Use')">
                <span>Not in Use</span>
              </button>
              <button mat-menu-item (click)="UpdateEqStaus(1,'In Use')">
                <span>In Use</span>
              </button>
              <button mat-menu-item (click)="UpdateEqStaus(2,'Parked')">
                <span>Parked</span>
              </button>
              <button mat-menu-item (click)="UpdateEqStaus(3,'Rental')">
                <span>Rental</span>
              </button>
              <button mat-menu-item (click)="UpdateEqStaus(4,'Single Inspection')">
                <span>Single Inspection</span>
              </button>
              <button mat-menu-item (click)="UpdateEqStaus(5,'Rebuild')">
                <span>Rebuild</span>
              </button>
            </mat-menu> -->
          </span>
        </div>
        <div style="padding-top: 10px;">
          <span *ngIf="equipmentDetails.EquipmentComments != null" (click)="addComment(equipmentDetails)"
            style="cursor: pointer;">
            <i class="material-icons upload-container__icon" style="color: #ed5565;">
              message
            </i>
          </span>
          <span *ngIf="equipmentDetails.EquipmentComments == null" style="cursor: pointer;">
            <i class="material-icons observation-image__icon" (click)="addComment(equipmentDetails)">
              message
            </i>
          </span>
        </div>
        <div>
          <button mat-icon-button>
            <img style="width: 33px;height: auto;"
              matTooltip="Carrier Rollers can be shown or hidden on Elevated Sprocket Dozers only by toggling this button"
              *ngIf="hasCRoller && ShowCRoller" class="chain-photo" (click)="HideShowCRoller()"
              src="/Content/Images/Carrier Roller Black.png">
            <img style="width: 33px;height: auto;" *ngIf="hasCRoller && !ShowCRoller"
              matTooltip="Carrier Rollers can be shown or hidden on Elevated Sprocket Dozers only by toggling this button"
              class="chain-photo" (click)="HideShowCRoller()" src="/Content/Images/Carrier Roller Grey.png">
          </button>
        </div>

        <!-- Summary Notes -->
        <div style="display: flex; align-items: center; margin-left: 100px;">
          <span style="font-size: 14px; font-weight: 600; color: #222;">
            {{'Equipment Summary Notes' | translate | async}}
          </span>
          <button 
            mat-icon-button
            [matTooltip]="'Equipment Summary Notes' | translate | async"
            (click)="openSummaryNotes()"
            style="width: 28px; height: 28px;">
            <span *ngIf="equipmentDetails.SummaryNotesExists"
            style="cursor: pointer;">
            <i class="material-icons upload-container__icon" style="color: #ed5565;">
              message
            </i>
          </span>
          <span *ngIf="!equipmentDetails.SummaryNotesExists" style="cursor: pointer;">
            <i class="material-icons observation-image__icon" >
              message
            </i>
          </span>
          </button>
        </div>
      </div>
    </div>
    <div class="panel__content flex flex--align-center">
      <div class="overall-eval-container">
        <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo"
          (click)="EdiEqImage(equipmentDetails.EquipmentPhoto)" />
        <div *ngIf="(!equipmentDetails.FamilyId==203 || !IsHtdrolicShovelWorksLikeRSH)"
          style="display: flex; flex-direction: column; gap: 2%;">
          <div
            class="div-worn bold font-size--xl margin-r--24 Eval-{{equipmentDetails.EvalL}}">
            L {{equipmentDetails.SumWornL | number:'1.0-1'}}{{equipmentDetails.SumWornL!=null ? '%' : '-'}}
          </div>
          <div
            class="div-worn bold font-size--xl margin-r--24 Eval-{{equipmentDetails.EvalR}}">
            R {{equipmentDetails.SumWornR | number:'1.0-1'}}{{equipmentDetails.SumWornR!=null ? '%' : '-'}}
          </div>
        </div>
        <!-- <div *ngIf="equipmentDetails.FamilyId!=203 && !IsHtdrolicShovelWorksLikeRSH"
        class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.Eval }}" style="margin-right: 1px;">
        {{equipmentDetails.PercentWorn | number:'1.0-1'}}% -->
        <!-- </div> -->
        <div style="align-content: center; padding-bottom: 13px; margin-left: -2px;">
          <mat-icon class="edit-icon" (click)="AvgComponentPopup()" style="cursor: pointer;"
            title="Click to adjust wear % calculation settings">
            edit
          </mat-icon>
        </div>
        <div
          *ngIf="(equipmentDetails.FamilyId==203 || IsHtdrolicShovelWorksLikeRSH) &&  (equipmentDetails.SumWornL==null || equipmentDetails.SumWornR==null) "
          class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.Eval }}" style="margin-right: 1px;">
          {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
        </div>

        <!-- <div *ngIf="(equipmentDetails.FamilyId==203|| IsHtdrolicShovelWorksLikeRSH)"
          style="display: flex; flex-direction: column;justify-content: space-evenly; margin-left: 0px;">
          <div *ngIf="equipmentDetails.SumWornL!=null"
            class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.SumWornL | wornPercentageToEval}}"
            style="font-size: 24px; text-align: start;    margin-right: 0px;  border-radius: 8px 8px 8px 8px">
            L {{equipmentDetails.SumWornL | number:'1.0-1'}}%
          </div>
          <div *ngIf="equipmentDetails.SumWornR!=null"
            class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.SumWornR | wornPercentageToEval}}"
            style="font-size: 24px; text-align: start;    margin-right: 0px;     border-radius: 8px 8px 8px 8px">
            R {{equipmentDetails.SumWornR | number:'1.0-1'}}%
          </div>
        </div> -->

        <div *ngIf="(equipmentDetails.FamilyId==203 || IsHtdrolicShovelWorksLikeRSH)"
          style="display: flex; flex-direction: column;justify-content: space-evenly; margin-left: 2px;">
          <div *ngIf="equipmentDetails.SumWornL!=null"
            class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.SumWornL | wornPercentageToEval}}"
            style="font-size: 24px; text-align: start;    margin-right: 0px;  border-radius: 8px 8px 8px 8px">
            {{equipmentDetails.MonoblockCMUL | number:'1.0-1' }} / {{
            equipmentDetails.MonoblockResidualL |
            number:'1.0-1'
            }}
          </div>
          <div *ngIf="equipmentDetails.SumWornR!=null"
            class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.SumWornR | wornPercentageToEval}}"
            style="font-size: 24px; text-align: start;    margin-right: 0px;     border-radius: 8px 8px 8px 8px">
            {{equipmentDetails.MonoblockCMUR | number:'1.0-1' }} / {{
            equipmentDetails.MonoblockResidualR |
            number:'1.0-1'
            }}
          </div>
        </div>


      </div>
      <div class="column-container flex-grow" style="margin-left: 1%;">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Customer') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.CustomerName}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Job Site') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.JobsiteName}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">{{ Translate('Serial Number') }}</span>
            <span *ngIf="editableSerialNo">{{equipmentDetails.SerialNumber}}</span>
            <span *ngIf="!editableSerialNo" class="text-block__important">
              <span>
                <input class="input-container__input" #dataInput [value]="equipmentDetails.SerialNumber"
                  [(ngModel)]="equipmentDetails.SerialNumber" focusOnShow />
              </span>

              <i class="material-icons save-button__icon editcancel" (click)="onSaveEquipmentDetail(1)">check</i>
              <i class="material-icons cancel-button__icon editcancel" (click)="onCancelEquipmentDetail(1)">close</i>
            </span>
            <span *ngIf="isAdminAllowEdit">
              <span *ngIf="editableSerialNo">
                <i class="material-icons text-container__edit" style="cursor: pointer;"
                  (click)="editEquipmentDetail(1)">edit</i>
              </span>
            </span>

          </div>


          <div class="text-block">
            <span class="text-block__label">{{ Translate('Unit Number') }}</span>
            <span *ngIf="editUnitNo">{{equipmentDetails.UnitNumber}}</span>
            <span *ngIf="!editUnitNo" class="text-block__important">
              <span>
                <input class="input-container__input" #dataInput [value]="equipmentDetails.UnitNumber" focusOnShow
                  [(ngModel)]="equipmentDetails.UnitNumber" />
              </span>
              <i class="material-icons save-button__icon editcancel" (click)="onSaveEquipmentDetail(2)">check</i>
              <i class="material-icons cancel-button__icon editcancel" (click)="onCancelEquipmentDetail(2)">close</i>

            </span>
            <span *ngIf="isAdminAllowEdit">
              <span *ngIf="editUnitNo">
                <i class="material-icons text-container__edit" style="cursor: pointer;"
                  (click)="editEquipmentDetail(2)">edit</i>
              </span>
            </span>

          </div>
        </div>
        <div class="column-container__column" *ngIf="equipmentDetails.AdditionalUnitNo != null ">
          <div class="text-block">
            <span class="text-block__label">{{ Translate('Additional Unit Number') }}</span>
            <span *ngIf="editAdditionalUnitNo">{{equipmentDetails.AdditionalUnitNo}}</span>
            <span *ngIf="!editAdditionalUnitNo" class="text-block__important">
              <span>
                <input class="input-container__input" #dataInput [value]="equipmentDetails.AdditionalUnitNo" focusOnShow
                  [(ngModel)]="equipmentDetails.AdditionalUnitNo" />
              </span>
              <i class="material-icons save-button__icon editcancel" (click)="onSaveEquipmentDetail(3)">check</i>
              <i class="material-icons cancel-button__icon editcancel" (click)="onCancelEquipmentDetail(3)">close</i>

            </span>
            <span *ngIf="isAdminAllowEdit">
              <span *ngIf="editAdditionalUnitNo && checkDateEdit(equipmentDetails)">
                <i class="material-icons text-container__edit" style="cursor: pointer;"
                  (click)="editEquipmentDetail(3)">edit</i>
              </span>
            </span>
          </div>




          <div class="text-block">
            <span class="text-block__label">

            </span>
            <span class="text-block__important">

            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Last Inspection Date') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.LastInspectionDate}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Next Inspection Date') }}
            </span>
            <span class="text-block__important">
              {{ equipmentDetails.NextInspectionDate }}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Meter Reading') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Smu}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Life to Date (LTD)') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Ltd}}
            </span>
          </div>
        </div>
        <div class="column-container__column" *ngIf="equipmentDetails.EnableDistTravelledTracking">
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Fwd Dist. ') }} ({{userUOD}})
            </span>
            <span class="text-block__important">
              {{convertDistanceKmToMi(equipmentDetails.DistanceForward)}}
            </span>
          </div>
          <div class="text-block">
            <div class="dist">
              <div>
                <span class="text-block__label">
                  {{ Translate('Rev Dist. ') }} ({{userUOD}})
                </span>
                <span class="text-block__important">
                  {{convertDistanceKmToMi(equipmentDetails.DistanceReverse)}}
                </span>
              </div>
              <div class="distpadding">
                <span class="text-block__label">
                  {{ Translate('Total ') }} ({{userUOD}})
                </span>
                <span class="text-block__important">
                  {{convertDistanceKmToMi(equipmentDetails.DistanceForward + equipmentDetails.DistanceReverse)}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="column-container__column" *ngIf="equipmentDetails.ShowPropelHrsPerc">
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Propel Hrs') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.propelHrs!=null? equipmentDetails.propelHrs:'-'}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Propel %') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.propelHrs!=null?equipmentDetails.propelPercentage : '-'}}
            </span>
          </div>
        </div>

        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Make') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Make}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Model') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Model}}
            </span>
          </div>
        </div>
        <div class="column-container__column" *ngIf="isBasicUser==1">
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Family') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Family}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{ Translate('Setup Date') }}
            </span>
            <span class="text-block__important">
              {{equipmentDetails.EquipmentSetupDate}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex columns" *ngIf="equipmentDetails != null && inspectionsLoaded && appUris != null" [@enterAnimation]>
    <div class="panel panel--tasks" style="flex-shrink: 0.1;">
      <div class="panel__header">
        <span class="panel__header__title">
          {{ Translate('Tasks') }}
        </span>
        <i *ngIf="isBasicUser!=1" class="material-icons" style="cursor: pointer;"
          title="Update user settings to advanced user to access other tasks.">info</i>
      </div>
      <div class="panel__content flex flex--align-stretch">



        <a class="square-button" *ngIf="isInspector && isBasicUser==1" (click)="newAction()">
          <i class="material-icons square-button__icon"
            title="Update user settings to advanced user to access other tasks">mode_edit</i>
          <span class="square-button__label">{{ Translate('Record Action') }}</span>

        </a>

        <a class="square-button" *ngIf="!isInspector && isBasicUser==1" style="color: lightgrey;">
          <i class="material-icons square-button__icon">mode_edit</i>
          <span class="square-button__label">{{ Translate('Record Action') }}</span>
        </a>

        <a class="square-button" (click)="openChangeJobsite()" *ngIf="isInspector && isBasicUser==1">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">{{ Translate('Change Jobsite') }}</span>
        </a>

        <a class="square-button" *ngIf="!isInspector && isBasicUser==1" style="color: lightgrey;">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">{{ Translate('Change Jobsite') }}</span>
        </a>
        <a class="square-button" (click)="openUpdateMeter()" *ngIf="isInspector && isBasicUser==1">
          <i class="material-icons square-button__icon">access_time</i>
          <span class="square-button__label">{{ Translate('Update Meter') }}</span>
        </a>
        <a class="square-button" *ngIf="!isInspector && isBasicUser==1" style="color: lightgrey;">
          <i class="material-icons square-button__icon">access_time</i>
          <span class="square-button__label">{{ Translate('Update Meter') }}</span>
        </a>

        <a class="square-button" (click)="openChangeMeterUnit()" *ngIf="isInspector && isBasicUser==1">
          <i class="material-icons square-button__icon">swap_horiz</i>
          <span class="square-button__label">{{ Translate('Change Meter Unit') }}</span>
        </a>

        <a class="square-button" *ngIf="!isInspector && isBasicUser==1" style="color: lightgrey;">
          <i class="material-icons square-button__icon">swap_horiz</i>
          <span class="square-button__label">{{ Translate('Change Meter Unit') }}</span>
        </a>
        <a class="square-button {{getDisable()}}" [matTooltip]="getEquipmentSetupTooltip()"
          (click)='SetupUnderCarriage()' *ngIf="isInspector && isBasicUser==1">
          <i class="material-icons square-button__icon">build</i>
          <span class="square-button__label">{{ Translate('Setup Undercarriage') }}</span>
        </a>
        <a class="square-button {{getDisable()}}" [matTooltip]="getEquipmentSetupTooltip()"
          *ngIf="!isInspector && isBasicUser==1" style="color: lightgrey;">
          <i class="material-icons square-button__icon">build</i>
          <span class="square-button__label">{{ Translate('Setup Undercarriage') }}</span>
        </a>

        <a class="square-button  {{getDisable()}}" (click)='SetupEquipment()' [matTooltip]="getEquipmentSetupTooltip()"
          *ngIf="isInspector && isBasicUser==1">
          <i class="material-icons square-button__icon">build</i>
          <span class="square-button__label">{{ Translate('Setup Equipment') }}</span>
        </a>

        <a class="square-button  {{getDisable()}}" [matTooltip]="getEquipmentSetupTooltip()"
          *ngIf="!isInspector && isBasicUser==1" style="color: lightgrey;">
          <i class="material-icons square-button__icon">build</i>
          <span class="square-button__label">{{ Translate('Setup Equipment') }}</span>
        </a>

        <a class="square-button" (click)="newInspection()"
          *ngIf='isInspector && !isRopeShovel() && hasComponents && !TempEnabled && !ThermEnabled && !IsHtdrolicShovelWorksLikeRSH'>
          <i class="material-icons square-button__icon">assignment</i>
          <span class="square-button__label">{{ Translate('New Inspection') }}</span>
        </a>

        <a class="square-button" [matMenuTriggerFor]="newinspectionMenu"
          *ngIf="hasAvailableMenuItems &&  (TempEnabled || ThermEnabled || IsHtdrolicShovelWorksLikeRSH || isRopeShovel())">
          <i class="material-icons square-button__icon">assignment</i>
          <span class="square-button__label">{{ Translate('New Inspection') }}</span>
          <mat-menu #newinspectionMenu="matMenu">
            <span mat-menu-item style="font-weight: bold;">
              {{
              'Select Inspection Type' | translate | async
              }}
            </span>

            <!-- Add ngIf to check if any of the buttons are available -->
            <ng-container *ngIf="isInspector">
              <button mat-menu-item (click)="newInspection()"
                *ngIf="!isRopeShovel() && hasComponents && !IsHtdrolicShovelWorksLikeRSH">
                {{ 'Undercarriage Inspection' | translate | async }}
              </button>
              <button mat-menu-item (click)="newInspectionRSH('Create Rope Shovel Inspection')" *ngIf="isRopeShovel()">
                {{ 'Rope Shovel Inspection' | translate | async }}
              </button>
              <button mat-menu-item (click)="newInspectionRSH('Create Hydraulic Shovel/Excavator Inspection')"
                *ngIf="IsHtdrolicShovelWorksLikeRSH">
                {{ 'Hydraulic Shovel Inspection' | translate | async }}
              </button>
              <button mat-menu-item *ngIf="TempEnabled && hasComponents" (click)="CreateNewTemperatureInspection()">
                {{ 'Temperature Inspection' | translate | async }}
              </button>
              <button mat-menu-item *ngIf="ThermEnabled" (click)="CreateNewThermographyInspection()">
                {{ 'Thermography Inspection' | translate | async }}
              </button>
              <button mat-menu-item *ngIf="enableManualInspection" (click)="GenerateTelerikPDF()">
                {{ 'Manual Inspection' | translate | async }}
              </button>
            </ng-container>
          </mat-menu>
        </a>





        <a class="square-button" style="color: lightgrey;" *ngIf='(!hasComponents && !ThermEnabled  ) || !isInspector '>
          <i class="material-icons square-button__icon">assignment</i>
          <span class="square-button__label">{{ Translate('New Inspection') }}</span>
        </a>
      </div>
    </div>


    <div class="panel panel--next-inspection" style="flex-shrink:0.1; margin-left: 0;" *ngIf="isBasicUser==1">
      <div class="panel__header" style="white-space: nowrap;">
        <span class="panel__header__title">
          {{ 'Inspection Planning' | translate | async }}
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch" *ngIf="equipmentDetails.IsManualHour">
        <div class="square-button" (click)="openInspectionPlannerDialog()" style="border:solid;border-color: red;">
          <i class="material-icons square-button__icon">event_note</i>
          <span class="smuReadings" style="color: black;">Smu/HrM:{{equipmentDetails.NextSmu}}</span>
          <span class="square-button__label" style="color: grey;">
            {{
            equipmentDetails.NextInspectionDate| date:'dd/MMM/yyyy'
            }}
          </span>
        </div>
      </div>
      <div class="panel__content flex flex--align-stretch"
        *ngIf="equipmentDetails.IsManualInspection && isDueForInspection()">
        <div class="square-button" (click)="openInspectionPlannerDialog()" style="border:solid;border-color: red;">
          <i class="material-icons square-button__icon">event_note</i>
          <span class="smuReadings">Smu/HrM:{{equipmentDetails.NextSmu}}</span>
          <span class="square-button__label">
            {{ equipmentDetails.NextInspectionDate| date:'dd/MMM/yyyy' }}
          </span>
        </div>
      </div>
      <div class="panel__content flex flex--align-stretch"
        *ngIf="equipmentDetails.IsManualInspection && !isDueForInspection()">
        <div class="square-button" (click)="openInspectionPlannerDialog()" style="border:solid;border-color: green;">
          <i class="material-icons square-button__icon">event_note</i>
          <span class="smuReadings">Smu/HrM:{{equipmentDetails.NextSmu}}</span>
          <span class="square-button__label">
            {{
            equipmentDetails.NextInspectionDate| date:'dd/MMM/yyyy'
            }}
          </span>
        </div>
      </div>
      <div class="panel__content flex flex--align-stretch"
        *ngIf="!equipmentDetails.IsManualInspection && !equipmentDetails.IsManualHour">
        <div class="square-button" (click)="openInspectionPlannerDialog()">
          <i class="material-icons square-button__icon">event_note</i>
          <span class="smuReadings">Smu/HrM:{{equipmentDetails.NextSmu}}</span>
          <span class="square-button__label">
            {{
            equipmentDetails.NextInspectionDate| date:'dd/MMM/yyyy'
            }}
          </span>
        </div>
      </div>
    </div>

    <div class="panel panel--inspections" style="margin-left:15px;">
      <div class="panel__header">
        <span class="panel__header__title">
          {{ Translate('Inspection History') }}
        </span>
        <!-- TT-9864 Point-3 -->
        <!-- <span class="panel__header__title" *ngIf="hasTemperatureInspection">
          <button mat-raised-button color="warn" (click)="OpenTemperatureHistory()">
            <img src="../../../../../Content/Images/thermometer-512.png"
              style="float:left;margin-right:0.5em;width: 24px; "> {{ Translate('Temperature') }}
          </button>
        </span> -->
      </div>


      <div class="panel__content flex flex--align-stretch">
        <div *ngFor="let inspection of inspections;"
          [class]="'square-button' + (inspection.Interpreted == false ? ' opaque' : '')"
          [matTooltip]="inspection.Interpreted==false  && !inspection.IsAction? ('Awaiting Interpretation' | translate | async): ''"
          [matMenuTriggerFor]="inspectionMenu">
          <!-- [matMenuTriggerFor]="inspection.IsAction==false? inspectionMenu:null" -->
          <img *ngIf="inspection.hasTemperature" src="../../../../../Content/Images/thermometer-512.png"
            style="margin-left:auto;width: 24px;margin-bottom: -20px;">
          <span *ngIf="inspection.IsThermography"
            style="margin-left:auto;width: 8px;font-size: 18px; margin-bottom: -20px;"><b>T</b></span>
          <span *ngIf="inspection.IsAction"
            style="margin-left:auto;width: 8px;font-size: 18px; margin-bottom: -20px;"><b>M</b></span>
          <i class="square-button__icon newEval-{{inspection.Eval}}" style="margin-left: 22px">{{inspection.Eval}}</i>
          <span class="smuReadings">Smu/HrM: {{inspection.Smu}}</span>
          <span class="smuReadings" *ngIf="equipmentDetails.EnableDistTravelledTracking">
            DOE:
            {{ convertDistanceKmToMi(inspection.Distance) }} {{ userUOD }}
          </span>
          <span class="square-button__label nowrap">{{inspection.Date}}</span>
          <a *ngIf="inspection.isDocAttached==true">
            <i class="material-icons">description</i>
            <span class="square-button__label">{{inspection.DocCount}}</span>
          </a>
          <mat-menu #inspectionMenu="matMenu">
            <button mat-menu-item (click)="openLink('rs-inspection', inspection.Id)"
              *ngIf="(isRopeShovel() || IsHtdrolicShovelWorksLikeRSH) && isInterpreter && !inspection.IsThermography">
              {{'View'| translate | async}}
            </button>
            <button mat-menu-item (click)="openLink('download', inspection.Id)"
              *ngIf="(isRopeShovel() ||IsHtdrolicShovelWorksLikeRSH)
                            && inspection.Interpreted  && !inspection.IsTIsThermographyhermography && !inspection.IsAction ">
              {{'PDF Report' | translate | async}}
            </button>
            <button mat-menu-item (click)="openLink('interpret', inspection.Id)"
              *ngIf="isInterpreter && !isRopeShovel() && !inspection.IsThermography && !inspection.IsAction && !IsHtdrolicShovelWorksLikeRSH">
              {{
              'Details'|
              translate | async
              }}
            </button>


            <button mat-menu-item
              *ngIf="inspection.QuoteId != 0 && !isRopeShovel()  && !inspection.IsThermography && !inspection.IsAction && !IsHtdrolicShovelWorksLikeRSH"
              (click)="DownloadTelerikPdf(inspection.Id, inspection.QuoteId, menuTrigger); $event.stopPropagation()"
              [disabled]="downloadingPdf">
              {{ downloadingPdf ? 'Generating PDF, please wait...' : ('PDF Report' | translate | async) }}
            </button>
            <button mat-menu-item
              *ngIf="isInspector && !isRopeShovel() && !inspection.IsThermography  && !inspection.IsAction && !IsHtdrolicShovelWorksLikeRSH"
              (click)="openLink('edit', inspection.Id)">
              {{'Edit' | translate | async}}
            </button>
            <button mat-menu-item
              *ngIf="isInterpreter && !isRopeShovel() && !inspection.IsThermography && !IsHtdrolicShovelWorksLikeRSH"
              (click)="openLink('interpret', inspection.Id)">
              {{'Interpret'| translate | async}}
            </button>

            <!--Thermogarphy-->
            <button mat-menu-item (click)="openLink('therm-inspection', inspection.Id)"
              *ngIf="isInterpreter && inspection.IsThermography && !inspection.IsAction">
              {{'View'| translate | async}}
            </button>
            <button mat-menu-item (click)="openLink('therm-pdf', inspection.Id)"
              *ngIf="isInterpreter && inspection.IsThermography && inspection.Interpreted && !inspection.IsAction">
              {{'PDF Report'| translate | async}}
            </button>

            <button mat-menu-item (click)="OpenDeleteInspection(inspection.Id)"
              *ngIf="isAdministrator && !inspection.IsThermography">
              {{'Hide Inspection'| translate | async}}
            </button>

            <button *ngIf="inspection.isDocAttached==true" mat-menu-item
              (click)="openAttachedDocs(inspection.Smu,inspection.Date, inspection.Id)">
              {{ 'View Documents'}}
            </button>
            <button *ngIf="inspection.isDocAttached==false" mat-menu-item
              (click)="openAttachedDocs(inspection.Smu,inspection.Date, inspection.Id)">
              {{'Add Doc.'}}
            </button>
          </mat-menu>
          <button mat-icon-button style="display:none;" [matMenuTriggerFor]="inspectionMenu"
            #menuTrigger="matMenuTrigger">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>




  <mat-tab-group animationDuration="0ms">


    <mat-tab label="{{ Translate('Overview') }}">

      <div *ngIf="isloaded">



        <!-- <div class="center" *ngIf="(equipmentDetails == null || equipmentDetails==null) && loading">
          <mat-spinner></mat-spinner>
        </div> -->
        <div style="display: flex;align-items: center; justify-content: center;background: white;font-size: 20px;"
          *ngIf="(systemIds==null || systemIds.length==0) && !loading">
          <i class="material-icons">warning</i>
          <span style="display: flex;flex-direction: row;height: 40px; align-items: center;margin-left: 1%;">

            {{ Translate('No Undercarriage components setup') }}
          </span>
        </div>
        <div class="columnsheadersmgr" *ngIf="hasComponents && isBasicUser==1">
          <mat-label style="margin-right: 8px; font-weight: bold; font-size: 14px; color: #1D2F36;">
            {{ "Display Columns for" | translate | async }}: 
          </mat-label>
          <mat-form-field style="width: 400px;" class="displaycolumnheadersfor">
            <mat-select multiple [(ngModel)]="dashboardPreferneceView" (selectionChange)="savePreferences($event)"
              style="min-width: 260px; height: 40px;
            display: inline !important; border: 1px solid #DfE7EF; color: #1D2F36; min-height: 40px;">
              <mat-option *ngFor="let column of DashboardPrefernceList"
                [value]="column.GridId">{{column.ColumnDisplayName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- --equipmentSystems!=null && equipmentSystems.length > 0 -->
          <!-- <span class="displaycolumnheadersfor">{{ "Display Columns for: " | translate | async }} </span>
          <mat-checkbox [(ngModel)]="showCMU"><span class="example-margin item__bottom">{{ "CMU" | translate | async
              }}</span></mat-checkbox>
          <mat-checkbox [(ngModel)]="showResLife100"><span class="example-margin">{{ "Res. Life" | translate | async }}
              100%</span></mat-checkbox>
          <mat-checkbox [(ngModel)]="showResLife120"><span class="example-margin">{{ "Res. Life" | translate | async }}
              120%</span></mat-checkbox>
          <mat-checkbox [(ngModel)]="showDOC" *ngIf="equipmentDetails.EnableDistTravelledTracking"><span
              class="example-margin">{{ "DOC" | translate | async }}</span></mat-checkbox>
          <mat-checkbox [(ngModel)]="showResDOC100" *ngIf="equipmentDetails.EnableDistTravelledTracking"><span
              class="example-margin">{{ "Res. DOC" | translate | async }} 100%</span></mat-checkbox>
          <mat-checkbox [(ngModel)]="showResDOC120" *ngIf="equipmentDetails.EnableDistTravelledTracking"><span
              class="example-margin">{{ "Res. DOC" | translate | async }} 120%</span></mat-checkbox>
          <mat-checkbox [(ngModel)]="showInstallDate"><span class="example-margin">{{ "Install Date" | translate | async
              }}</span></mat-checkbox> -->
          <mat-checkbox [(ngModel)]="editComponent" *ngIf="isAdministrator && !isFamilyRS" style="margin-left: 31px;">
            <span class="example-margin">
              {{
              "Edit Component" | translate | async
              }}
            </span>
          </mat-checkbox>
          <!-- TT-9602 -->
          <button *ngIf="addCompRight" mat-button (click)="openColumnSettingsDialog()" class="settings-button">
            <mat-icon>add</mat-icon>
            <span class="example-margin">
              {{'Add Component' | translate | async}}</span>
          </button>
        </div>
        <div *ngIf="reloadEquipmentOverview">
          <div *ngFor="let systemId of systemIds">
            <app-equipment-overview [equipmentDetails]="equipmentDetails" [isInspector]="isInspector"
              [editComponent]="editComponent" [showResDOC120]="showResDOC120" [showResDOC100]="showResDOC100"
              [showInstallDate]="showInstallDate" [showDOC]="showDOC" [showResLife120]="showResLife120"
              [showCMU]="showCMU" [showResLife100]="showResLife100"
              [showReading]="showReading" [showWorn0]="showWorn0" [showWorn100]="showWorn100"
              [isBasicUser]="isBasicUser" [equipmentID]="equipmentId" [systemId]="systemId" [showBrand]="showBrand"
              [showBudgetLife]="showBudgetLife" [showBushTurned]="showBushTurned"
              [showProjectedLife100]="showProjectedLife100" [showProjectedLife120]="showProjectedLife120"
              [showDifference]="showDifference" [showResidualDOC]="showResidualDOC"
              [showPurchaseCost]="showPurchaseCost" [showRepairCost]="showRepairCost" [showWorkOrder]="showWorkOrder" 
              [showActualWearRate]="showActualWearRate" [showBudgetWearRate]="showBudgetWearRate" [showHideCRoller]="ShowCRoller" [showReplacementDate]="showReplacementDate"
              (hasComponentChange)="handleHasComponent($event)" (hasComponentCR)="handleHasComponentCR($event)" [EvalautionRange]="EvalautionRange" [userUOM]="userUOM">
            </app-equipment-overview>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{ Translate('Inspection History')
              }}" *ngIf="inspections?.length>0">

              <div style="display: flex;align-items: center; justify-content: center;background: white;font-size: 20px;"
                   *ngIf=" systemIds==null || systemIds.length==0">
                <i class="material-icons">warning</i>
                <span style="display: flex;flex-direction: row;height: 40px; align-items: center; margin-left: 1%;">

                  {{ Translate('No Undercarriage components setup') }}
                </span>
              </div>
              <app-inspection-history *ngIf="equipmentDetails!=null" [equipmentId]="equipmentId" [eqName]="eqName"
                                      [ThermEnabled]="ThermEnabled" [MaintenaceEnables]="MaintenaceEnables" [FamilyId]="equipmentDetails.FamilyId"
                                      [LastInspectionWorn]="equipmentDetails.LastInspectionWorn"
                                      (showCurrentOrForecast)="receiveData($event)"></app-inspection-history>
</mat-tab>

    <mat-tab label="{{ Translate('Observation Point History') }}"
      *ngIf="inspections?.length>0 && (isRopeShovel()|| IsHtdrolicShovelWorksLikeRSH)">
      <app-observationpoint-history [equipmentId]="equipmentId" [eqName]="eqName" [FamilyId]="equipmentDetails.FamilyId"
        [ModelId]="equipmentDetails.ModelId"></app-observationpoint-history>
    </mat-tab>
    <mat-tab label="{{ Translate('Graph') }}" *ngIf="inspections?.length>1 &&  isBasicUser==1">


      <diV *ngIf="CompInspections?.length>3" style="display: flex; flex-direction :column; background-color: white;">
        <div style="text-align: center;">
          <div style="font-size: x-large;margin-top: 1%;">
            {{ Translate('Left Side - Component Wear Graph and Forecast') }}
          </div>

          <div class="graph_selected_point">
            <div *ngIf="enableLeft"
              style="margin-top: 20px; padding: 15px; background: #f0f0f0; border: 1px solid #ccc;">
              <strong>{{'Left' | translate | async}} {{ selectedSeries }}</strong> {{ selectedData }}
            </div>
          </div>
          <fusioncharts *ngIf="!loadingChart" [width]="width" [height]="height" [type]="type" [dataFormat]="dataFormat"
            [dataSource]="dataSourceLEFT" (dataplotClick)="handlePlotClickL($event.eventObj, $event.dataObj,1)">
          </fusioncharts>

        </div>

        <div style="margin-top: 2%;text-align: center;">
          <div style="font-size: x-large;margin-top: 1%;">
            {{ Translate('Right Side - Component Wear Graph and Forecast')}}
          </div>
          <div class="graph_selected_point">
            <div *ngIf="enableRight"
              style="margin-top: 20px; padding: 15px; background: #f0f0f0; border: 1px solid #ccc;">
              <strong>{{'Right' | translate | async}} {{ selectedSeries }}</strong> {{ selectedData }}
            </div>
          </div>
          <fusioncharts *ngIf="!loadingChart" [width]="width" [height]="height" [type]="type" [dataFormat]="dataFormat"
            [dataSource]="dataSourceRIGHT" (dataplotClick)="handlePlotClickR($event.eventObj, $event.dataObj,2)">
          </fusioncharts>

        </div>


      </diV>




    </mat-tab>
    <!-- TT-1966 -->
    <mat-tab label="{{ Translate('Action History') }}" *ngIf="isBasicUser==1">
      <app-action-history [equipmentId]="equipmentId" [eqName]="eqName"
        [EnableDistTravelledTracking]="EnableDistTravelledTracking"></app-action-history>
    </mat-tab>

    <mat-tab label="{{ Translate('Temperature Inspection') }}" *ngIf="hasTemperatureInspection">
      <app-temperature-inspection-history-dialog [equipmentId]="equipmentId"
        [TemperatureInspectionList]="TemperatureInspectionList"></app-temperature-inspection-history-dialog>
    </mat-tab>
  </mat-tab-group>
</div>


<!-- <div class="overlay" *ngIf="showPopup">
  <div class="popup">
    <div class="popup-header">
    <h4>Over all equipment Percent Worn</h4>

    <i class="material-icons ttmodal__close-button"
       (click)="closePopup()"
       matTooltip="Close">
      close
    </i>
  </div>
<div *ngFor="let item of EquipmentCompartmentTypeModel">
    <mat-checkbox [(ngModel)]="item.IsSelected">
      {{ item.CompartTypeName }}
    </mat-checkbox>
  </div>
    <div  style="text-align: right; margin-top: 10px;">
      <button mat-raised-button color="warn" >Save</button>
      <button mat-button (click)="closePopup()">Close</button>
    </div>
  </div>
</div> -->
